const API_ERROR_CODE_PREFIX = /^[A-Z][A-Z0-9]*_[A-Z0-9_]*:\s*/;

export function stripApiErrorCode(message: string): string {
    const text = message.trim();
    const readable = text.replace(API_ERROR_CODE_PREFIX, '').trim();
    return readable || text;
}
